import { sanitizeSvgMarkup } from './sanitizeSvgMarkup';
import { buildIconAriaProps } from '../iconAriaProps';
import { jsx as _jsx } from "react/jsx-runtime";
export default function SvgIcon({
  svg,
  ariaLabel
}) {
  const sanitized = sanitizeSvgMarkup(svg);
  if (!sanitized) return null;
  return /*#__PURE__*/_jsx("span", Object.assign({
    style: {
      display: 'inline-block'
    }
  }, buildIconAriaProps(ariaLabel), {
    dangerouslySetInnerHTML: {
      __html: sanitized
    }
  }));
}